import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import DropdownMenu from "./Dropdown";
import InformationIcon from "../information_icon";
import DynamicInput from "./DynamicInput";

const TopBorder = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  height: 7px;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  background-color: #FCFCFC;
  transition: background-color 250ms;
`;

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1 1 0px;
  padding: 24px;
  background-color: white;
  cursor: pointer;
  border-radius: 8px;
  box-shadow: 0px 4px 32px 0px rgba(0,0,0, 0.25);
  transition: transform 250ms, margin-top 250ms, margin-bottom 250ms, box-shadow 250ms;
  margin-bottom: 0px;
  ${props => !props.active ? 'pointer-events: none; opacity: 0.5' : ''}

  qds-icon {
    min-width: 20px;
    width: 20px;
    max-width: 20px;
    min-height: 20px;
    height: 20px;
    max-height: 20px;
  }
`;



const ContainerWrapper = styled.div`
  display: flex;
  flex: 1 1 0px;

  ${props => props.active ? `
    :hover {
      ${Container} {
        ${TopBorder} {
          background-color: ${props.secondaryColor || '#008a16'};
        }
        box-shadow: 0px 4px 32px 0px rgba(0,0,0, 0.25);
        margin-top: -8px;
        margin-bottom: 8px;
      }
    }
  ` : ''}
`;

const ConfigurationNameAndCountryWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

const ConfigNameWrapper = styled.div`
  display: flex;
  flex-direction: row;
  color: rgb(51, 51, 51);
  align-items: center;
  height: 50px;
  min-width: 170px;
  max-width: 200px;
`;

const ConfigName = styled.span`
  display: block;
  overflow: hidden;
  white-space:nowrap;
  text-overflow:ellipsis;
  font-weight: bold;
  font-size: 18px;
  line-height: 21px;
  text-align: left;
  color: #333333;
`;

const ConfigurationCountryWrapper = styled.div`
  display: flex;
  height: 50px;
  align-items: center;
`;

const Flag = styled.img`
  height: 30px;
  width: 30px;

  @media (max-width: 400px) {
    height: 20px;
    width: 20px;
  }
`;

const FlagText = styled.span`
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 15px;
  margin-left: 5px;
  margin-right: 5px;
`;

const CountryHint = styled.div`
  color: ${props => props.primaryColor};
  padding: 10px;
  min-width: 200px;
  font-size: 14px;
`;

const ConfigurationInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 0px;
  justify-content: flex-end;
`;

const ConfigurationDate = styled(ConfigName)`
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #626469;
`;

const PreventExpandDiv = styled.div``;

const ConfigRangeWrapper = styled.div`
  display: inline-block;
  padding: 5px 10px;
  background-color: #EDEDED;
  border-radius: 0px 100px 100px 0px;
  margin-top: 10px;
`;

const ConfigurationRange = styled(ConfigName)`
  color: #4D4E53;
  font-size: 12px;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  white-space: pre-wrap;
`;

const TechnologyText = styled.div`
  font-weight: 400;
  font-size: 12px;
  color: rgba(98, 100, 105, 0.68);
  min-width: 150px;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const TechnologyAndActionsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
`;

const ActionsWrapper = styled.div`
  display: flex;
  flex: 1 1 0px;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 10px;
`;

const ItemWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const IconWrapper = styled.div`
  margin-left: 10px;
`;

const ListItem = styled.div`
  padding: 6px 10px;
  white-space: nowrap;
  :hover {
    background-color: rgb(237, 237, 237);
  }
`;

const ListWrapper = styled.div`
    position: absolute;
    padding: 10px;
    -webkit-transform: translateX(-100%) translateX(8px) !important;
    -ms-transform: translateX(-100%) translateX(8px) !important;
    transform: translateX(-100%) translateX(8px) !important;
    display: block;
    background-color: #ffffff;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.15);
    z-index: 20;
`;

const standardize_color = (str) => {
  var ctx = document.createElement('canvas').getContext('2d');
  ctx.fillStyle = str;
  return ctx.fillStyle.length > 0 && ctx.fillStyle[0] === '#' ? ctx.fillStyle : rgb2hex(ctx.fillStyle);
}

const rgb2hex = (rgb) => {
  rgb = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
  return (rgb && rgb.length === 4) ? "#" +
    ("0" + parseInt(rgb[1], 10).toString(16)).slice(-2) +
    ("0" + parseInt(rgb[2], 10).toString(16)).slice(-2) +
    ("0" + parseInt(rgb[3], 10).toString(16)).slice(-2) : '';
}

const hexToRgb = hex =>
  hex.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i
    , (m, r, g, b) => '#' + r + r + g + g + b + b)
    .substring(1).match(/.{2}/g)
    .map(x => parseInt(x, 16));


const rgb_is_light = (color) => {
  const brightness = ((color[0] * 299) + (color[1] * 587) + (color[2] * 114)) / 1000;
  return brightness > 155;
}

const WorkspaceOpenConfigurationButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #FFFFFF;
  border: 1px solid #EDECEC;
  color: ${props => props.primaryColor || '#0075a3'};
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  box-sizing: border-box;

  min-width: 45px;
  width: 45px;
  max-width: 45px;
  min-height: 45px;
  height: 45px;
  max-height: 45px;

  ${props => props.$size ? `
    qds-icon {
      min-width: ${props.$size}px;
      width: ${props.$size}px;
      max-width: ${props.$size}px;
      min-height: ${props.$size}px;
      height: ${props.$size}px;
      max-height: ${props.$size}px;
    }
  ` : ``}
`;

const WorkspaceAddToProject = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${props => props.primaryColor || '#0075a3'};
  color: white;
  color:  ${props => props.primaryTextColor || 'white'};
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  margin-left: 10px;
  border: 1px solid  ${props => props.primaryColor || '#0075a3'};
  box-sizing: border-box;

  min-width: 45px;
  width: 45px;
  max-width: 45px;
  min-height: 45px;
  height: 45px;
  max-height: 45px;

  ${props => props.$size ? `
    qds-icon {
      min-width: ${props.$size}px;
      width: ${props.$size}px;
      max-width: ${props.$size}px;
      min-height: ${props.$size}px;
      height: ${props.$size}px;
      max-height: ${props.$size}px;
    }
  ` : ``}
`;

const eventInputEditEnabledName = 'iac-input-edit-enabled';

class SavedConfigurationCard extends React.Component {

  static propTypes = {
    id: PropTypes.string,
    onConfigurationRestore: PropTypes.func,
    flagURL: PropTypes.string,
    country: PropTypes.string,
    technologyIconComponent: PropTypes.object,
    countryWarningLabel: PropTypes.string,
    onRename: PropTypes.func,
    onRenameLinkClick: PropTypes.func,
    labelRenaming: PropTypes.string,
    primaryColor: PropTypes.string,
    secondaryColor: PropTypes.string,
    dropdownActions: PropTypes.array,
    iconActions: PropTypes.array,
    workspaceActions: PropTypes.array,
    configurationName: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = {
      primaryTextColor: rgb_is_light(hexToRgb(standardize_color(props.primaryColor || '#008a16'))) ? 'rgb(98,100,105)' : 'white',
      secondaryTextColor: rgb_is_light(hexToRgb(standardize_color(props.secondaryColor || '#42B4E6'))) ? 'rgb(98,100,105)' : 'white',
      isEditingName: false,
      dropdownActionsOpened: false,
    };
  }

  // Close all other opened inputs
  componentDidMount = () => {
    window.addEventListener(eventInputEditEnabledName, this.onEditEnabled);
  }

  componentWillUnmount = () => {
    window.removeEventListener(eventInputEditEnabledName, this.onEditEnabled);
  }

  onEditEnabled = () => {
    this.setState({ isEditingName: false });
  }

  onRenameLinkClick = () => {
    this.setState({ isEditingName: true });
  }

  handleRename = (newName) => {
    this.props.onRename(newName);
    this.setState({ isEditingName: false });
  }

  cancelRename = () => {
    this.setState({ isEditingName: false });
  }

  renderDropdownActions = () => {
    return (this.props.dropdownActions || []).map((actionObject) => {
      return (
        <ListItem key={actionObject.key} onClick={(event) => { event.stopPropagation(); actionObject.action(); }}>
          <ItemWrapper data-close>
            <qds-icon name={actionObject.icon}></qds-icon>
            <IconWrapper>
              {actionObject.label}
            </IconWrapper>
          </ItemWrapper>
        </ListItem>
      );
    });
  }

  renderIconActions = () => {
    return (this.props.iconActions || []).map((actionObject) => {
      return (
        <IconWrapper
          key={actionObject.key}
          title={actionObject.hint}
          onClick={(event) => {
            event.stopPropagation();
            actionObject.action();
          }}
        >
          <qds-button icon-name={actionObject.icon} importance="subdued"></qds-button>
        </IconWrapper>
      );
    });
  }

  renderWorkspaceActions = () => {
    return (this.props.workspaceActions || []).map((actionObject) => {
      if (actionObject.type === 'full') {
        return (
          <WorkspaceAddToProject
            primaryColor={this.props.primaryColor}
            primaryTextColor={this.state.primaryTextColor}
            key={actionObject.key}
            onClick={(event) => {
              event.stopPropagation();
              actionObject.action();
            }}
            $size={actionObject.size}
          >
            <qds-icon name={actionObject.icon}></qds-icon>
          </WorkspaceAddToProject>
        );
      } else if (actionObject.type === 'flat') {
        return (
          <WorkspaceOpenConfigurationButton
            primaryColor={this.props.primaryColor}
            key={actionObject.key}
            onClick={(event) => {
              event.stopPropagation();
              actionObject.action();
            }}
            $size={actionObject.size}
          >
            <qds-icon name={actionObject.icon}></qds-icon>
          </WorkspaceOpenConfigurationButton>
        );
      }

      return null;
    });
  }

  renderOptionList = () => {
    const { labelRenaming } = this.props;

    const handleRenameClick = () => {
      window.dispatchEvent(new Event(eventInputEditEnabledName));
      this.onRenameLinkClick();
    };

    return (
      <ListWrapper>
        <ListItem onClick={(event) => { event.stopPropagation(); handleRenameClick(event); }}>
          <ItemWrapper data-close>
            <qds-icon name="pencil"></qds-icon>
            <IconWrapper>
              {labelRenaming}
            </IconWrapper>
          </ItemWrapper>
        </ListItem>
        {this.renderDropdownActions()}
      </ListWrapper>
    );
  }

  render() {

    return (
      <ContainerWrapper active={this.props.active} secondaryColor={this.props.secondaryColor}>
        <Container
          id= {this.props.id}
          active={this.props.active}
          onClick={() => {
            if (!this.state.isEditingName) {
              this.props.onConfigurationRestore();
            }
          }}
        >
        <TopBorder />
        <ConfigurationNameAndCountryWrapper>
          <ConfigNameWrapper>
            {this.state.isEditingName ? (
              <DynamicInput
                initialValue={this.props.configurationName}
                setValue={this.handleRename}
                withCancel={true}
                cancel={this.cancelRename}
                customInputProps={{ name: "configurationName", maxLength: "20" }}
              />
            ) : (
              <ConfigName>{this.props.configurationName}</ConfigName>
            )}
          </ConfigNameWrapper>
          <ConfigurationCountryWrapper>
            <Flag src={this.props.flagURL}></Flag>
            <FlagText>{this.props.country}</FlagText>
            <DropdownMenu
              data-clickable
              toggleElement={<InformationIcon />}
              containerElement={<CountryHint primaryColor={this.props.primaryColor}>{this.props.countryWarningLabel}</CountryHint>}
            >
            </DropdownMenu>
          </ConfigurationCountryWrapper>
        </ConfigurationNameAndCountryWrapper>
        <ConfigurationInfoWrapper>
            <ConfigurationDate title={this.props.dateLabel}>
              {this.props.dateLabel}
            </ConfigurationDate>
            <PreventExpandDiv>
              <ConfigRangeWrapper>
                <ConfigurationRange>
                  {this.props.computeConfigurationRange()}
                </ConfigurationRange>
              </ConfigRangeWrapper>
            </PreventExpandDiv>
            <TechnologyAndActionsWrapper>
              <TechnologyText>
                {this.props.technologyIconComponent}
                {this.props.computeStarterType()}
              </TechnologyText>
              <ActionsWrapper>
                {this.props.launchFromWorkspace ? (
                  <>
                    {this.renderWorkspaceActions()}
                  </>
                ) : (
                  <>
                    {this.renderIconActions()}
                    <DropdownMenu
                      data-clickable
                      toggleElement={
                        <IconWrapper>
                          <qds-button icon-name="dots-3-horizontal" importance="subdued"></qds-button>
                        </IconWrapper>
                      }
                      containerElement={this.renderOptionList()}
                      forceLeft
                    />
                  </>
                )}
              </ActionsWrapper>
            </TechnologyAndActionsWrapper>
          </ConfigurationInfoWrapper>
          </Container>
      </ContainerWrapper>
    );
  }
}

export default SavedConfigurationCard;
